import { caymanToday } from '../utils/dateFormat';

export const MEETING_API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/meeting-summaries`;
export const meetingHeaders = () => ({ Authorization: `Basic ${btoa(':' + sessionStorage.getItem('admin_password'))}` });
export const emptyMeeting = () => ({ title: '', meeting_date: caymanToday(), meeting_time: '', location: '',
  attendees: [{ name: '', organisation: 'Pawsome Ventures', email: '' }], purpose: '', discussion: '', decisions: [''],
  action_items: [{ action: '', owner: '', due_date: '', status: 'open' }], next_meeting_date: '',
  next_meeting_time: '', next_meeting_location: '', next_meeting_notes: '', status: 'draft' });
export const meetingForm = data => {
  const form = Object.fromEntries(Object.keys(emptyMeeting()).map(k => [k, data[k]]));
  form.attendees = form.attendees.length ? form.attendees.map(a => ({ email: '', ...a })) : [{ name: '', organisation: '', email: '' }];
  if (!form.decisions.length) form.decisions = [''];
  if (!form.action_items.length) form.action_items = [{ action: '', owner: '', due_date: '', status: 'open' }];
  return form;
};
export const meetingError = async response => {
  if (response.status === 401) return 'Your session has expired. Sign in again before saving.';
  const data = await response.json().catch(() => ({}));
  return Array.isArray(data.detail) ? data.detail.map(e => `${e.loc?.slice(1).join(' ')}: ${e.msg}`).join('; ') : data.detail || 'Could not process the meeting summary. Please retry.';
};
export const meetingRequest = async (path = '', options = {}) => {
  const response = await fetch(MEETING_API + path, { ...options, cache: 'no-store',
    headers: { ...meetingHeaders(), 'Content-Type': 'application/json', ...options.headers } });
  if (!response.ok) throw new Error(await meetingError(response));
  return response.json();
};
export const downloadMeeting = async (id, title) => {
  const response = await fetch(`${MEETING_API}/${id}/pdf`, { headers: meetingHeaders(), cache: 'no-store' });
  if (!response.ok) throw new Error(await meetingError(response));
  const url = URL.createObjectURL(await response.blob());
  const a = document.createElement('a'); a.href = url;
  a.download = `Pawsome-Meeting-Summary-${(title || 'Meeting').replace(/[^\p{L}\p{N} ._-]/gu, '').slice(0, 80)}.pdf`;
  a.click(); setTimeout(() => URL.revokeObjectURL(url), 10000);
};